t = require('views/internal/teacup-with-helpers')('search_instant_results')

module.exports =  t.renderable ({ savedSearchesEnabled, upsellEnabled }) =>
  formatWithArgs = (text) -> t.format(text, {
    archived: "archived",
    attachments: "attachments",
    board: "board",
    checklist: "checklist",
    comment: "comment",
    cover: "cover",
    created: "created",
    day: "day",
    description: "description",
    due: "due",
    edited: "edited",
    has: "has",
    id: "id",
    is: "is",
    label: "label"
    list: "list",
    member: "member",
    members: "members",
    month: "month",
    name: "name",
    open: "open",
    overdue: "overdue",
    sort: "sort",
    starred: "starred",
    stickers: "stickers",
    week: "week"
  })

  t.div '.search-header-options', ->
    t.div '.js-saved-search-links', ->
      t.a '.quiet.dark-hover.search-header-options-option.js-see-all-saved-searches', { href: '#' }, ->
        t.icon 'back', 'back-to-saved-searches'
      if savedSearchesEnabled || (!savedSearchesEnabled && upsellEnabled)
        t.a '.quiet.dark-hover.search-header-options-option.js-save-this-search', { href: '#' }, ->
          t.icon 'star', 'save-this-search'
      t.span '.quiet.search-header-options-option.mod-save.js-current-search.hide', { href: '#' }, ->
        t.icon 'star'
        t.span '.js-current-search-name'

  t.div '.search-results-section.js-save-this-search-menu.hide', ->
    if savedSearchesEnabled
      t.div '.search-results-section-header', ->
        t.h4 ->
          t.format 'what-would-you-like-to-call-this-search'

      t.form '.js-save-this-search-form', ->
        t.input '.js-saved-search-name-input', { type: 'text', style: 'margin-bottom: 4px;' }
        t.input '.primary.js-save-this-search-submit', { type: 'submit', value: t.l('save') }
        t.a '.quiet.js-save-this-search-cancel', { href: '#', style: 'margin-left: 6px;' }, ->
          t.format 'nevermind'

    else
      t.h2 ->
        t.format 'upgrade-to-add-new-saved-searches'

      t.p { style: 'font-size: 16px; line-height: 1.2;' }, ->
        t.format 'you-can-add-new-saved-searches-with-trello-gold-or-get-saved-searches-for-your-entire-organization-with-business-class'

      t.p ->
        t.a '.button.js-gold-link', { target: '_blank', href: '/gold' }, ->
          t.format 'check-out-trello-gold'
        t.a '.button.js-business-class-link', { target: '_blank', href: '/business-class' }, ->
          t.format 'check-out-business-class'

      t.hr()

  t.div '.search-results-section.js-search-suggestions.u-clearfix.hide', ->

    t.div '.search-results-section-header', ->
      t.h4 ->
        t.format 'did-you-mean-ellipsis'

    t.div '.js-search-suggestions-list'

  t.div '.search-results-section.js-saved-searches.u-clearfix.hide', ->

    t.div '.search-results-section-header', ->
      t.h4 ->
        t.format 'saved-searches'

    t.p '.quiet.hide.js-no-saved-searches', ->
      t.format 'you-have-no-saved-searches-to-save-a-search-start-searching-and-click-save-this-search-in-the-upper-corner'

    t.div '.js-saved-searches-list'

    t.hr()

  t.div '.js-search-results.u-clearfix.u-relative.hide', ->

    t.div '.search-results-section.js-card-results.u-clearfix.hide', ->
      t.div '.search-results-section-header.u-clearfix', ->
        t.h4 ->
          t.format 'cards'
      t.div '.js-list'
      t.span '.search-loading.hide.js-loading-cards', { href: '#' }, ->
        t.format 'loading-ellipsis'
      t.a '.show-more.hide.js-show-more-cards', { href: '#' }, ->
        t.format 'show-more-cards-ellipsis'

    t.div '.search-results-section.js-board-results.u-clearfix.hide', ->
      t.div '.search-results-section-header', ->
        t.h4 ->
          t.format 'boards'
      t.ul '.board-results-list.js-list'
      t.a '.show-more.hide.js-show-more-boards', { href: '#' }, ->
        t.format 'show-more-boards-ellipsis'

    t.div '.search-results-section.js-member-results.u-clearfix.hide', ->
      t.div '.search-results-section-header', ->
        t.h4 ->
          t.format 'members'
      t.ul '.js-list.pop-over-member-list'
      t.a '.show-more.hide.js-show-more-members', { href: '#' }, ->
        t.format 'show-more-members-ellipsis'

    t.div '.search-results-section.js-org-results.u-clearfix.hide', ->
      t.div '.search-results-section-header', ->
        t.h4 ->
          t.format 'organizations'
      t.ul '.org-list.js-list'
      t.a '.show-more.hide.js-show-more-orgs', { href: '#' }, ->
        t.format 'show-more-organizations-ellipsis'

  t.div '.search-tips.hide.js-no-input.search-empty-state', ->
    t.p '.search-tips-helper.quiet.js-search-tips-helper', ->
      t.span '.search-empty-state-description', ->
        formatWithArgs 'refine-your-search-with-operators-like-at-member-label-is-archived-and-has-attachments'
      t.text ' '
      t.a '.js-show-search-tips', { href: '#' }, ->
        t.format 'learn-more-ellipsis'

    t.div '.search-tips-list.js-search-tips-list.hide', ->

      t.p '.quiet', ->
        formatWithArgs 'search-operators-help-you-find-specific-cards-and-create-highly-tailored-lists-trello-will-suggest-operators-for-you-as-you-type-but-here-s-a-full-list-to-keep-in-mind-you-can-add-to-any-operator-to-do-a-negative-search-such-as-has-members-to-search-for-cards-without-any-members-assigned'

      t.dl ->

        t.dt ->
          t.format 'at-name'
        t.dd ->
          formatWithArgs 'returns-cards-assigned-to-a-member-if-you-start-typing-at-trello-will-suggest-members-for-you-member-also-works-at-me-will-include-only-your-cards'

        t.dt ->
          t.format 'label'
        t.dd ->
          formatWithArgs 'returns-labeled-cards-trello-will-suggest-labels-for-you-if-you-start-typing-and-the-label-you-are-looking-for-label-also-works'

        t.dt ->
          formatWithArgs 'board-id'
        t.dd ->
          formatWithArgs 'returns-cards-within-a-specific-board-if-you-start-typing-board-trello-will-suggest-boards-for-you-you-can-search-by-board-name-too-such-as-board-trello-to-search-only-cards-on-boards-with-trello-in-the-board-name'

        t.dt ->
          formatWithArgs 'list-name'
        t.dd ->
          formatWithArgs 'returns-cards-within-the-list-named-name-or-whatever-you-type-besides-name'

        t.dt ->
          formatWithArgs 'has-attachments'
        t.dd ->
          formatWithArgs 'returns-cards-with-attachments-has-description-has-cover-has-members-and-has-stickers-also-work-as-you-would-expect'

        t.dt ->
          formatWithArgs 'due-day'
        t.dd ->
          formatWithArgs 'returns-cards-due-within-24-hours-due-week-due-month-and-due-overdue-also-work-as-expected-you-can-search-for-a-specific-day-range-for-example-adding-due-14-to-search-will-include-cards-due-in-the-next-14-days'

        t.dt ->
          formatWithArgs 'created-day'
        t.dd ->
          formatWithArgs 'returns-cards-created-in-the-last-24-hours-created-week-and-created-month-also-work-as-expected-you-can-search-for-a-specific-day-range-for-example-adding-created-14-to-the-search-will-include-cards-created-in-the-last-14-days'

        t.dt ->
          formatWithArgs 'edited-day'
        t.dd ->
          formatWithArgs 'returns-cards-edited-in-the-last-24-hours-edited-week-and-edited-month-also-work-as-expected-you-can-search-for-a-specific-day-range-for-example-adding-edited-21-to-the-search-will-include-cards-edited-in-the-last-21-days'

        t.dt ->
          formatWithArgs 'description-checklist-comment-and-name'
        t.dd ->
          formatWithArgs 'returns-cards-matching-the-text-of-card-descriptions-checklists-comments-or-names-for-example-comment-fix-it-will-return-cards-with-fix-it-in-a-comment'

        t.dt ->
          formatWithArgs 'is-open-and-is-archived'
        t.dd ->
          t.format 'returns-cards-that-are-either-open-or-archived-trello-returns-both-types-by-default'

        t.dt ->
          formatWithArgs 'is-starred'
        t.dd ->
          t.format 'only-include-cards-on-starred-boards'

        t.dt ->
          formatWithArgs 'sort-created'
        t.dd ->
          formatWithArgs 'sorts-cards-by-date-created-sort-edited-and-sort-due-also-work-as-expected'

  t.div '.search-warning.hide.js-no-results', ->
    t.format 'no-results'

  t.p '.search-warning.hide.js-searching', ->
    t.format 'searching-ellipsis'

  t.p '.search-warning.hide.js-err', ->
    t.format 'your-search-produced-an-error'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/search_instant_results.coffee